@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Users"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="full_name" title="Name">
    <ng-template let-user kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="user.full_name" [link]="['/agreement', $agreementId(), 'user', user.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="user_name" title="Email">
    <ng-template let-user kendoGridCellTemplate [unityTyped]="T">
      <unity-link-mailto-shared [variants]="['centered']" [emailAddress]="user.user_name" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="user_role_name" title="Role" />
  <kendo-grid-column field="role_status" title="Role Status">
    <ng-template let-user kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="user.role_status" [value]="user.role_status" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
